import { render, staticRenderFns } from "./livesub.vue?vue&type=template&id=d8c70312&"
import script from "./livesub.vue?vue&type=script&lang=js&"
export * from "./livesub.vue?vue&type=script&lang=js&"
import style0 from "./livesub.vue?vue&type=style&index=0&id=d8c70312&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports